module.exports = __webpack_public_path__ + "img/cbb438c.png";